module.exports = __webpack_public_path__ + "static/media/S1-37-Gowba-cod73.5cfded09.png";